import { useEffect, useRef, useState } from 'react';

import { playerApi } from '../../api/resources/players';
import { useSession } from '../../app/session';
import { AuthLayout } from './AuthLayout';
import { PersonalInfoForm } from '../profile/PersonalInfoForm';
import { Button } from '../../components/ui/Button';
import { useToast } from '../../components/ui/Toast';
import { apiErrorMessage } from '../../lib/errors';
import { isGender } from '../../lib/gender';
import { useLocale } from '../../lib/useLocale';

export function IncompleteProfileScreen() {
  const { t } = useLocale();
  const { viewer, refresh, logout } = useSession();
  const toast = useToast();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const toastId = useRef<number | null>(null);

  useEffect(() => {
    toastId.current = toast.toast({
      title: t('auth.profileIncompleteToast'),
      tone: 'warning',
      duration: Infinity,
    });
    return () => {
      if (toastId.current != null) toast.dismiss(toastId.current);
    };
  }, [t, toast]);

  return (
    <AuthLayout title={t('auth.personalInfoTitle')} fillViewport fadeKey="incomplete-profile" fadeAppear>
      <PersonalInfoForm
        initial={{
          nickname: viewer?.nickname ?? '',
          birthday: viewer?.birthday ?? '',
          gender: isGender(viewer?.gender ?? '') ? viewer!.gender! : undefined,
          countryCode: viewer?.countryCode ?? '',
        }}
        submitLabel={t('common.save')}
        busy={busy}
        error={error}
        onSubmit={async (values) => {
          setError(null);
          setBusy(true);
          try {
            await playerApi.updateProfile({
              nickname: values.nickname,
              birthday: values.birthday || null,
              gender: values.gender,
              countryCode: values.countryCode,
            });
            await refresh();
            toast.success(t('profile.profileUpdated'));
          } catch (err) {
            setError(apiErrorMessage(err, t));
          } finally {
            setBusy(false);
          }
        }}
      />
      <div className="mt-6 flex justify-center">
        <Button type="button" variant="ghost" size="sm" onClick={() => void logout()}>
          {t('common.signOut')}
        </Button>
      </div>
    </AuthLayout>
  );
}
